export default {
  title: "Личный кабинет",
  collections: "Коллекции",
  savedQueries: "Сохранённые запросы",
  newCollection: "Новая коллекция",
  collectionTitle: "Название",
  collectionDescription: "Описание",
  isPublic: "Публичная коллекция",
  items: "{{count}} записей",
  emptyCollections: "Пока нет коллекций. Создайте первую, чтобы сохранять карточки.",
  emptyQueries: "Нет сохранённых запросов.",
  runQuery: "Открыть",
  subscribe: "Подписка на обновления",
  kindSearch: "Поиск",
  kindSparql: "SPARQL",
  deleteCollection: "Удалить коллекцию?",
  deleteQuery: "Удалить сохранённый запрос?",
  deleteQueryFailed: "Не удалось удалить сохранённый запрос. Он остался в списке.",
  hello: "Здравствуйте, {{name}}",
  portal: {
    pageTitle: "Личный кабинет",
    pageSubtitle: "Портал Российской государственной библиотеки: сервисы и анкета участника.",
    navAria: "Разделы личного кабинета",
    overviewNav: "Обзор",
    welcome: "Здравствуйте, {{name}}!",
    welcomeHint:
      "Здесь вы управляете анкетой, уведомлениями и переходите к мероприятиям и сервисам библиотеки.",
    completionLabel: "Заполнено: {{percent}}%",
    profileComplete: "Профиль полностью заполнен",
    completionProgressAria: "Заполнение профиля",
    servicesTitle: "Сервисы портала",
    services: {
      events: { title: "Мероприятия", desc: "Афиша, регистрация и материалы событий библиотеки." },
      deposit: { title: "Депонирование", desc: "Подача произведений и сопровождение депозита." },
      admin: { title: "Администрирование", desc: "Роли и пользователи — только при соответствующих правах." },
    },
    anketaHint: "Расскажите о себе: это поможет подбирать мероприятия.",
    completionMissingTitle: "Что ещё заполнить",
    completionMissingGoAria: "Перейти к заполнению: {{label}}",
  },
  tabs: {
    personal: "Мои данные",
    education: "Образование",
    languages: "Языки",
    work: "Работа",
    portfolio: "Портфолио",
    creative: "Самоопределение",
    accounts: "Аккаунты",
    collections: "Коллекции",
    notifications: "Уведомления",
  },
  languages: {
    title: "Языки",
    code: "Код языка",
    level: "Уровень",
    add: "Добавить",
    empty: "Языки пока не указаны.",
  },
  work: {
    title: "Работа",
    organization: "Организация",
    position: "Должность",
    add: "Добавить",
    empty: "Опыт работы пока не указан.",
  },
  portfolio: {
    title: "Портфолио",
    itemTitle: "Название",
    url: "Ссылка",
    add: "Добавить",
    empty: "Достижений пока нет.",
  },
  creative: {
    title: "Самоопределение",
    empty: "Справочник ролей пока пуст.",
    loadFailed: "Не удалось загрузить самоопределение.",
    current: "Текущие значения профиля",
    direction: "Направление",
    subdirection: "Поднаправление",
    role: "Роль",
  },
  accounts: {
    title: "Аккаунты",
    email: "Email",
    displayName: "Отображаемое имя",
    hint: "ФИО по частям и PDF профиля появятся, когда поля будут в контракте nbr-api.",
  },
  password: {
    title: "Смена пароля",
    action: "Изменить пароль",
    changed: "Пароль успешно изменён.",
    currentInvalid: "Текущий пароль указан неверно.",
    failed: "Не удалось изменить пароль.",
  },
  profile: {
    title: "Профиль",
    bio: "О себе",
    phone: "Телефон",
    city: "Город",
    save: "Сохранить профиль",
    saved: "Профиль сохранён",
    loadFailed: "Не удалось загрузить профиль.",
    saveFailed: "Не удалось сохранить профиль.",
  },
  education: {
    title: "Образование",
    institution: "Учебное заведение",
    specialty: "Специальность",
    add: "Добавить",
    empty: "Записей об образовании пока нет.",
    delete: "Удалить",
  },
  notifications: {
    title: "Уведомления",
    empty: "Нет уведомлений.",
    unread: "Непрочитанные",
    markRead: "Прочитать",
    loadFailed: "Не удалось загрузить уведомления.",
    open: "Открыть уведомления",
  },
  links: {
    eventsPortal: "Портал мероприятий",
    depositsPortal: "Портал депонирования",
    notifications: "Уведомления",
  },
}
